export default "__VITE_ASSET__C1oG8IlQ__"